import { AccessDeniedError, UnexpectedError } from "../../domain/errors";
import { DuplicatedNfError } from "../../domain/errors/duplicated-nf-error";
import { UnauthorizedError } from "../../domain/errors/unauthorized-error";
import { Receipt, ReceiptNF } from "../../domain/models/receipt-model";
import { SaveReceipt } from "../../domain/usecases/save-receipt";
import { HttpClient, HttpStatusCode } from "../protocols/http";

export class DbSaveReceipt implements SaveReceipt {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}
  async save(receipt: Receipt): Promise<boolean> {
    const res = await this.httpClient.request({
      url: this.url,
      method: "post",
      body: receipt,
    });

    switch (res.statusCode) {
      case HttpStatusCode.ok:
        return true;
      case HttpStatusCode.forbidden:
        throw new DuplicatedNfError(res.body.error.data);
      case HttpStatusCode.unauthorized:
        throw new UnauthorizedError();
      default:
        throw new UnexpectedError();
    }
  }
}
